"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardWidgetItem = void 0;
const dashboard_widget_component_1 = __importDefault(require("./dashboard-widget.component"));
var dashboard_widget_item_component_1 = require("./dashboard-widget-item.component");
Object.defineProperty(exports, "DashboardWidgetItem", { enumerable: true, get: function () { return __importDefault(dashboard_widget_item_component_1).default; } });
exports.default = dashboard_widget_component_1.default;
